export const findAuthorOrSigner = (authorOrSignerObjects, authorOrSigner) => {
	return authorOrSignerObjects.find((authorOrSignerObject) => authorOrSignerObject?._id === authorOrSigner) || null;
};

// check if author or signer part of list
export const arrayIncludes = (array: Array<any>, propertyToCheck: string, fromIndex: number): boolean => {
	let arrayLength = 0;

	try {
		arrayLength = array.length;
	} catch (ermahgerd) {
		arrayLength = 0;
	}

	for (let index = fromIndex; index < arrayLength; index++) {
		if (array[index] && array[index] === propertyToCheck) {
			return true;
		}
	}
	return false;
};
